@let theming = metaData()['theming'];

<app-website-config-form-expansion-panel [title]="'Farbdesign'">

    <div class="color-row">
        <div class="individuell-color">
            <button mat-stroked-button (click)="colorPicker.click()" class="color-picker-button">Individuelle
                Farbe</button>
            <input #colorPicker class="color-input-field" [colorPicker]="theming.colors.primaryColor"
                [cpOutputFormat]="'hex'" [cpAlphaChannel]="'disabled'" [cpWidth]="'500'" [cpHeight]="'auto'"
                [style.background]="theming.colors.primaryColor" [cpPresetColors]="colorStrings"
                [cpPresetLabel]="'Vordefinierte Farbdesign'" [cpCloseClickOutside]="true"
                (colorPickerChange)="onPrimaryColorChange($event)" />
        </div>

        <mat-button-toggle-group [value]="theming.lightMode" (change)="updateLightModeTheming($event.value)">
            <mat-button-toggle [value]="true">Helles Design</mat-button-toggle>
            <mat-button-toggle [value]="false">Dunkles Design</mat-button-toggle>
        </mat-button-toggle-group>
    </div>


    <div class="color-palette">
        @for (color of colorOptions; track color;) {
        <button mat-raised-button
            [ngStyle]="{'background-color': color.primaryColor, 'color': getContrastYIQ(color.primaryColor)}"
            (click)="updateColorTheming(color.primaryColor)" class="color-button">
            {{ color.name }}
        </button>
        }
    </div>

    <div class="color-row">
        <button mat-raised-button
            [ngStyle]="{'background-color': theming.colors.primaryColor, 'color': getContrastYIQ(theming.colors.primaryColor)}"
            class="color-button">
            Ausgewählte Hauptfarbe
        </button>
    </div>

</app-website-config-form-expansion-panel>

<app-website-config-form-expansion-panel [title]="'Typography'">
    <div class="admin-row no-border-bottom">
        <label for="font-select" class="admin-text typography-field">Überschriften</label>
        <mat-form-field appearance="fill" style="margin-bottom: -1.25em; width: 12rem;">
            <mat-select id="font-select" [(ngModel)]="theming.typography.brandTypography"
                (selectionChange)="updateTypographyTheming($event.value)" panelClass="admin-theme">
                <mat-option *ngFor="let font of fontFamilies" [value]="font">
                    <span [ngStyle]="{'font-family': font}">{{ font.split(',')[0] }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <p [ngStyle]="{'font-family': theming.typography.brandTypography}">
            Beispieltext in der ausgewählten Schriftart.
        </p>
    </div>
    <mat-divider></mat-divider>
    <div class="admin-row no-border-bottom">
        <label for="font-select" class="admin-text typography-field">Text</label>
        <mat-form-field appearance="fill" style="margin-bottom: -1.25em; width: 12rem;">
            <mat-select id="font-select" [(ngModel)]="theming.typography.plainTypography"
                (selectionChange)="updateTypographyTheming(undefined, $event.value)" panelClass="admin-theme">
                <mat-option *ngFor="let font of fontFamilies" [value]="font">
                    <span [ngStyle]="{'font-family': font}">{{ font.split(',')[0] }}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <p [ngStyle]="{'font-family': theming.typography.plainTypography}">
            Beispieltext in der ausgewählten Schriftart.
        </p>
    </div>
</app-website-config-form-expansion-panel>